import React from "react";
import { Block, Icon, Layer, useThemeName } from "thorium-ui";
import logos from "../../assets/svg/logos.svg";

export const SocialLinks = () => {
   const themeName = useThemeName();
   const fillClr = themeName === "dark" ? "white" : "black";

   return (
      <Layer
         justify="evenly"
         style={{ paddingTop: "2em", textAlign: "center" }}
      >
         <Block className="animate fade slideY">
            <a
               href="https://www.linkedin.com/in/jeffrey-puls/"
               target="_blank"
               rel="noreferrer noopener"
               title="@Jeffrey Puls"
            >
               <Icon
                  src={`${logos}#linkedinLogo`}
                  fill={fillClr}
                  width={50}
                  height={50}
               />
            </a>
         </Block>
         <Block className="animate fade slideY delay-125">
            <a
               href="https://github.com/j-puls"
               target="_blank"
               rel="noreferrer noopener"
               title="@j-puls"
            >
               <Icon
                  src={`${logos}#gitLogo`}
                  fill={fillClr}
                  width={50}
                  height={50}
               />
            </a>
         </Block>

         <Block className="animate fade slideY delay-375">
            <a
               href="https://www.npmjs.com/~j-puls"
               target="_blank"
               rel="noreferrer noopener"
               title="~j-puls"
            >
               <Icon
                  src={`${logos}#npmLogo`}
                  fill={fillClr}
                  width={60}
                  height={60}
               />
            </a>
         </Block>
         <Block className="animate fade slideY delay-375">
            <a
               href="https://dev.to/jpuls"
               target="_blank"
               rel="noreferrer noopener"
               title="@Jeff Puls"
            >
               <Icon
                  src={`${logos}#devLogo`}
                  fill={fillClr}
                  width={60}
                  height={60}
               />
            </a>
         </Block>
         <Block
            all={12}
            style={{ paddingTop: "2em" }}
            className="animate fade slideY"
         >
            <span>Find me at these places.</span>
         </Block>
      </Layer>
   );
};

export default SocialLinks;
